module.exports = __webpack_public_path__ + "static/media/burger_menu.4bc42036.svg";